import type { Span, SpanProcessor } from "@opentelemetry/sdk-trace-web"

/** Stamps `user.id` on each span, read per span so it appears once the user logs in. */
export class UserSpanProcessor implements SpanProcessor {
  constructor(private readonly getUserId: () => string | null | undefined) {}

  onStart(span: Span): void {
    // Guard getUserId: it runs on every span, and a throw would break the request.
    try {
      const userId = this.getUserId()
      if (userId) {
        span.setAttribute("user.id", userId)
      }
    } catch {
      // Best-effort — swallow.
    }
  }

  onEnd(): void {}

  forceFlush(): Promise<void> {
    return Promise.resolve()
  }

  shutdown(): Promise<void> {
    return Promise.resolve()
  }
}
